import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Card, Table, Form, Badge, Spinner, Alert, Nav } from "react-bootstrap";
import PageLayout from "../../../../layouts/PageLayout";
import { apiGet, errorText, date, APPLICATION_STATUS_VARIANT } from "../../../Seller/sellerApi";

const TABS = [
    ["pending", "Waiting for review"],
    ["draft", "In progress"],
    ["rejected", "Rejected"],
    ["approved", "Approved"],
    ["all", "All"],
];

export default function SellerApplicationsList() {
    const navigate = useNavigate();
    const [status, setStatus] = useState("pending");
    const [region, setRegion] = useState("");
    const [search, setSearch] = useState("");
    const [rows, setRows] = useState([]);
    const [counts, setCounts] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const load = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await apiGet("/admin/seller-applications", { status, region: region || undefined, search: search || undefined });
            setRows(res.data?.data || []);
            setCounts(res.data?.counts || {});
        } catch (e) {
            setError(errorText(e, "Could not load applications."));
        } finally {
            setLoading(false);
        }
    }, [status, region, search]);

    useEffect(() => {
        const t = setTimeout(load, 300);
        return () => clearTimeout(t);
    }, [load]);

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card mb-4">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">Seller Applications</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to="/dashboard" className="mc-breadcrumb-link">Home</Link></li>
                                <li className="mc-breadcrumb-item">Seller Applications</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <Card className="border-0 shadow-sm rounded-4">
                        <Card.Body className="p-4">
                            <Nav variant="tabs" activeKey={status} onSelect={(k) => setStatus(k)} className="mb-3">
                                {TABS.map(([key, label]) => (
                                    <Nav.Item key={key}>
                                        <Nav.Link eventKey={key}>
                                            {label}
                                            {key !== "all" && counts[key] ? <Badge bg="secondary" className="ms-1">{counts[key]}</Badge> : null}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                            <Row className="g-2 mb-3">
                                <Col md={5}>
                                    <Form.Control placeholder="Search name, email or phone" value={search} onChange={(e) => setSearch(e.target.value)} />
                                </Col>
                                <Col md={3}>
                                    <Form.Select value={region} onChange={(e) => setRegion(e.target.value)} aria-label="Country">
                                        <option value="">All countries</option>
                                        <option value="local">Pakistan</option>
                                        <option value="international">International</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {loading ? (
                                <div className="text-center py-5"><Spinner animation="border" /></div>
                            ) : rows.length === 0 ? (
                                <p className="text-muted text-center py-4 mb-0">No applications here.</p>
                            ) : (
                                <Table hover responsive className="align-middle mb-0">
                                    <thead>
                                        <tr>
                                            <th>Applicant</th>
                                            <th>Country</th>
                                            <th>Email</th>
                                            <th>Storage</th>
                                            <th>Payment methods</th>
                                            <th>Status</th>
                                            <th>Submitted</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((r) => (
                                            <tr key={r.id} style={{ cursor: "pointer" }} onClick={() => navigate(`/admin/seller-applications/${r.id}`)}>
                                                <td>
                                                    <strong>{r.name}</strong>
                                                    <small className="d-block text-muted">{r.phone}</small>
                                                </td>
                                                <td>{r.country || r.country_code || "-"}</td>
                                                <td>
                                                    {r.email}
                                                    <small className="d-block">{r.email_verified ? <Badge bg="success">Verified</Badge> : <Badge bg="secondary">Not verified</Badge>}</small>
                                                </td>
                                                <td>{r.storage_preference === "admin_store" ? "Watches Pool store (5%)" : r.storage_preference === "own_store" ? "Own store (14%)" : "-"}</td>
                                                <td>{r.payment_methods_count}</td>
                                                <td><Badge bg={APPLICATION_STATUS_VARIANT[r.account_status] || "secondary"}>{r.account_status}</Badge></td>
                                                <td>{date(r.submitted_at)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}
